package com.wintermar.inspection.feature.presentation.inspection.landing.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.button.IconButton
import com.wintermar.inspection.core.ui.component.datetime.util.DateTimeUtil
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.widget.CircularProgress
import com.wintermar.inspection.core.ui.widget.table_container.ItemTableContainer
import com.wintermar.inspection.feature.domain.model.inspection.InspectionModel
import com.wintermar.inspection.feature.util.inspection_status.InspectionStatusView
import com.wintermar.inspection.graphql.type.InspectionStatus
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_more_horizontal

@Composable
fun InspectionLandingItemWide(
    data: InspectionModel,
    color: ThemeColor = LocalAppTheme.current.color,
    onClick: () -> Unit,
    onMoreClick: () -> Unit
) {
    ItemTableContainer(
        onClick = onClick
    ) {
        TextBodySmall(text = data.templateName, modifier = Modifier.weight(1f))
        TextBodySmall(text = data.vesselName, modifier = Modifier.weight(1f))
        Column(
            modifier = Modifier.weight(1f)
        ) {
            CircularProgress(
                progress = data.totalAnswer,
                total = data.totalQuestion
            )
        }
        Column(
            modifier = Modifier.weight(1f)
        ) {
            InspectionStatusView(status = data.status, asBadge = true)
        }
        TextBodySmall(
            text = DateTimeUtil.getLocalSystemDisplay(
                data.conducted
            ),
            modifier = Modifier.weight(1f)
        )

        Row(
            modifier = Modifier.weight(1f),
            horizontalArrangement = Arrangement.End
        ) {
            TextBodySmall(
                text = if (data.status == InspectionStatus.COMPLETED) DateTimeUtil.getLocalSystemDisplay(
                    data.lastUpdated
                ) else "",
                modifier = Modifier.weight(1f)
            )

            IconButton(
                icon = Res.drawable.ic_more_horizontal,
                backgroundColor = Color.Transparent,
                tint = color.icon.subtle,
                onClick = {
                    onMoreClick()
                }
            )
        }
    }
}
